export const SORTABLE_FIELDS_EVENTS = [
  'name',
  'created_at',
  'start_date',
  'display_at_home',
  'private'
];
export const SHOWING_FIELDS_MEMBERSHIPLANS = [
  'id',
  'name',
  'url',
  'organization_name',
  'count',
  'requires_approval',
  'price',
  'auto_renewal',
  'type'
];
export const SHOWING_FIELDS_EVENTS = [
  'real_id',
  'name',
  'created_at',
  'free_event',
  'organization_name',
  'requires_approval',
  'start_date',
  'min_price',
  'actions',
  'private',
  'display_at_home'
];
export const SHOWING_FIELDS_CATELOG_PAGES = [
  'name',
  'number_of_events',
  'url',
  'created_at',
  'actions',
  'active'
];
export const BLACK_LIST_FIELDS_ORGANIZATIONS = ['icered_id'];
export const SORTABLE_FIELDS_ORGANIZATIONS = [
  'name',
  'created_at',
  'custom_contact_limit',
  'charity'
];
export const SHOWING_FIELDS_USERS = [
  'id',
  'first_name',
  'last_name',
  'created_at',
  'email',
  'verified',
  'reset_password',
  'actions'
];
export const SHOWING_FIELDS_ADS = [
  'order',
  'link',
  'description',
  'active',
  'actions'
];
export const ROWS_PER_PAGE = 100;



// WEBPACK FOOTER //
// ./src/constants.js